<template>
  <SportFeaturePlaceholder
    sport-label="Tennis"
    title="Edit Tennis Team"
    description="Tennis team editing page is now scaffolded with route-level parity to basketball."
    primary-cta="Open Tennis Dashboard"
    :primary-route="{ name: 'TennisTeamDashboard' }"
    :back-route="{ name: 'TennisTeamDashboard' }"
  />
</template>

<script>
import SportFeaturePlaceholder from "@/routes/match_hub/shared/SportFeaturePlaceholder.vue";
export default { name: "TennisTeamEdit", components: { SportFeaturePlaceholder } };
</script>
